import meloAttributeReducer from './meloAttribute.reducer';
export { default as meloAttributeActions } from './meloAttribute.actions';
export { types as meloAttributeTypes } from './meloAttribute.actions';
export { default as meloAttributeSelectors } from './meloAttribute.selectors';
export default meloAttributeReducer;
